import React from 'react'

export default function BarList({ items, max }: { items: { label: string; value: number }[]; max?: number }) {
  const m = typeof max === 'number' ? max : Math.max(1, ...items.map(i => i.value))
  return (
    <div className="space-y-2">
      {items.map(i => (
        <div key={i.label} className="flex items-center gap-3">
          <div className="flex-1 h-2 rounded bg-gray-200 dark:bg-gray-700">
            <div className="h-2 rounded bg-indigo-600 dark:bg-indigo-400" style={{ width: `${Math.min(100, (i.value / m) * 100)}%` }} />
          </div>
          <div className="min-w-[140px] text-sm text-gray-900 dark:text-white">{i.label}</div>
          <div className="w-12 text-right text-sm text-gray-700 dark:text-gray-300">{i.value}</div>
        </div>
      ))}
    </div>
  )
}
